import { AndamentoAceite } from './../../models/processos.model';
import { PerfilService } from './../../services/perfil.service';
import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { showError } from 'src/app/shared/utils/functions/notification.function';

@Component({
  selector: 'app-modal-status-assinatura',
  templateUrl: './modal-status-assinatura.component.html',
  styleUrls: ['./modal-status-assinatura.component.scss']
})

export class ModalStatusAssinaturaComponent implements OnInit {
  mdbRef: MDBModalRef;

  id: any;
  andamentoAceite: AndamentoAceite = {
    progressoPorcentagem: 0,
    numTotalAssinaturasNecessarias: 0,
    numTotalAssinaturasRealizadas: 0,
    representantes: []
  };

  constructor(
    public modalRef: MDBModalRef,
    private perfilService: PerfilService,
  ) { }

  ngOnInit() {
    this.acompanharTermo();
  }

  acompanharTermo() {
    this.perfilService.statusAndamentoAceite(this.id).subscribe(
      res => this.andamentoAceite = res,
      err => showError("", err.message)
    )
  }

  closeModal() {
    return this.modalRef.hide();
  }
}
